var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-menu",
        _vm._b(
          {
            attrs: {
              "max-width": 290,
              "close-on-content-click": false,
              transition: "scroll-y-transition",
              "min-width": "auto",
              "min-height": "auto",
              left: "",
              "offset-y": ""
            },
            scopedSlots: _vm._u([
              {
                key: "activator",
                fn: function(ref) {
                  var on = ref.on
                  var attrs = ref.attrs
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex",
                        class: { "flex-column": _vm.vertical },
                        style: { gap: _vm.vertical ? "0.75rem" : "1rem" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _vm.useLabelAbove
                              ? _c("span", { staticClass: "filter-label" }, [
                                  _vm._v(_vm._s(_vm.labelStart) + " ")
                                ])
                              : _vm._e(),
                            _c(
                              "v-text-field",
                              _vm._b(
                                {
                                  ref: "startInput",
                                  staticClass: "new-ux align-icon-search",
                                  style: { "max-width": _vm.fieldMaxWidth },
                                  attrs: {
                                    value: _vm.formatMonthDate(_vm.startDate),
                                    label: !_vm.useLabelAbove
                                      ? _vm.labelStart
                                      : undefined,
                                    readonly: "",
                                    placeholder: "MM/AAAA",
                                    "hide-details": "",
                                    dense: "",
                                    outlined: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.selectInput(on, true, $event)
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "prepend-inner",
                                        fn: function() {
                                          return [
                                            _c("icon-svg", {
                                              attrs: {
                                                name: "calendar",
                                                size: "20",
                                                color: _vm.colorIconeCalendario
                                              }
                                            })
                                          ]
                                        },
                                        proxy: true
                                      },
                                      _vm.clearable && _vm.startDate
                                        ? {
                                            key: "append",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "#8E8E8E",
                                                      "aria-label":
                                                        "Limpar data inicial"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.clearDate(
                                                          true,
                                                          $event
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v(" mdi-close-circle ")]
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        : null
                                    ],
                                    null,
                                    true
                                  )
                                },
                                "v-text-field",
                                attrs,
                                false
                              )
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _vm.useLabelAbove
                              ? _c("span", { staticClass: "filter-label" }, [
                                  _vm._v(_vm._s(_vm.labelEnd) + " ")
                                ])
                              : _vm._e(),
                            _c(
                              "v-text-field",
                              _vm._b(
                                {
                                  ref: "endInput",
                                  staticClass: "new-ux align-icon-search",
                                  style: { "max-width": _vm.fieldMaxWidth },
                                  attrs: {
                                    value: _vm.formatMonthDate(_vm.endDate),
                                    label: !_vm.useLabelAbove
                                      ? _vm.labelEnd
                                      : undefined,
                                    readonly: "",
                                    placeholder: "MM/AAAA",
                                    "hide-details": "",
                                    dense: "",
                                    outlined: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.selectInput(on, false, $event)
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "prepend-inner",
                                        fn: function() {
                                          return [
                                            _c("icon-svg", {
                                              attrs: {
                                                name: "calendar",
                                                size: "20",
                                                color: _vm.colorIconeCalendario
                                              }
                                            })
                                          ]
                                        },
                                        proxy: true
                                      },
                                      _vm.clearable && _vm.endDate
                                        ? {
                                            key: "append",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "#8E8E8E",
                                                      "aria-label":
                                                        "Limpar data final"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.clearDate(
                                                          false,
                                                          $event
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v(" mdi-close-circle ")]
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        : null
                                    ],
                                    null,
                                    true
                                  )
                                },
                                "v-text-field",
                                attrs,
                                false
                              )
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ]
                }
              }
            ]),
            model: {
              value: _vm.showMenu,
              callback: function($$v) {
                _vm.showMenu = $$v
              },
              expression: "showMenu"
            }
          },
          "v-menu",
          _vm.$attrs,
          false
        ),
        [
          _c(
            "div",
            { staticClass: "bg-white filter-dates container-filter" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center"
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          _vm.year--
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v(" mdi-chevron-left ")])],
                    1
                  ),
                  _c(
                    "span",
                    { staticClass: "text-heading-small text-black-light" },
                    [_vm._v(" " + _vm._s(_vm.year) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          _vm.year++
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v(" mdi-chevron-right ")])],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "d-flex mt-1.5rem",
                  staticStyle: { "flex-wrap": "wrap", "row-gap": "4px" }
                },
                _vm._l(_vm.MONTHS, function(month) {
                  return _c(
                    "div",
                    {
                      key: month.value,
                      staticClass: "item-month",
                      class: {
                        "item-month-between": _vm.isBetweenDates(month),
                        "item-month-selected-first":
                          _vm.startDate === month.mask,
                        "item-month-selected-last": _vm.endDate === month.mask
                      },
                      on: {
                        click: function($event) {
                          return _vm.selectDate(month)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "font-medium text-sm" }, [
                        _vm._v(" " + _vm._s(month.text) + " ")
                      ])
                    ]
                  )
                }),
                0
              ),
              _c("v-divider", { staticClass: "my-1rem" }),
              _c(
                "div",
                { staticClass: "d-flex justify-content-between" },
                _vm._l(_vm.options, function(option) {
                  return _c(
                    "div",
                    {
                      key: option.text,
                      staticClass: "item-option",
                      class: {
                        "item-option-selected": option === _vm.optionSelected
                      },
                      on: {
                        click: function($event) {
                          return _vm.selectOption(option)
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "font-semibold text-xs" }, [
                        _vm._v(" " + _vm._s(option.text) + " ")
                      ])
                    ]
                  )
                }),
                0
              ),
              _c(
                "div",
                { staticClass: "d-flex justify-end" },
                [
                  _c(
                    "BaseButton",
                    {
                      staticClass: "mt-5",
                      attrs: {
                        primary: "",
                        sm: "",
                        text: "",
                        minWidth: "80px"
                      },
                      on: {
                        click: function($event) {
                          _vm.showMenu = false
                        }
                      }
                    },
                    [_vm._v(" Filtrar ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }